"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var epsilon_ajax_request_1 = require("../../utils/epsilon-ajax-request");
var EpsilonSectionRecommended = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{section: JQuery; params: { id: string}}} control
     */
    function EpsilonSectionRecommended(section) {
        /**
         * AJAXING =)
         * @type {boolean}
         */
        this.ajax = false;
        this.section = section;
        this.context = this.section.container;
        this.actions = this.section.params.actions.length;
        this.handleDismissals();
        this.handleEvents();
    }
    EpsilonSectionRecommended.prototype.handleDismissals = function () {
        this._dismissPlugin();
        this._dismissAction();
    };
    /**
     * Handle Events
     */
    EpsilonSectionRecommended.prototype.handleEvents = function () {
        this.context.on('click', '.epsilon-close-recommended-section', function (e) {
            e.preventDefault();
            jQuery(this).find('span').toggleClass('dashicons-arrow-down-alt2');
            jQuery('.recommended-actions_container').slideToggle(200);
        });
        jQuery(document).on('epsilon-plugin-activated', function (event, data) {
            var container = jQuery('span#' + data.plugin).parents('.epsilon-recommended-plugins'), next = container.next();
            container.fadeOut('200', function () {
                next.css({ opacity: 1, height: 'initial' }).fadeIn('200');
            });
        });
    };
    /**
     * Dismiss Plugin
     * @private
     */
    EpsilonSectionRecommended.prototype._dismissPlugin = function () {
        var section = this;
        var trigger = this.context.find('.epsilon-recommended-plugin-button');
        trigger.on('click', function (e) {
            var self = jQuery(this);
            /**
             * Get the container
             * @type {JQuery}
             */
            var container = self.parents('.epsilon-recommended-actions-container'), 
            /**
             * Get the next element ( this will be shown next )
             */
            next = container.next(), 
            /**
             * Get the title
             *
             * @type {JQuery}
             */
            title = container.parents('.control-section-epsilon-section-recommended-actions').find('h3'), 
            /**
             * Create the args object for the AJAX call
             *
             * action [ Class, Method Name ]
             * args [ parameters to be sent to method ]
             *
             * @type {{action: [*], args: {id: *, option: *}}}
             */
            args = {
                action: ['Epsilon_Notify_System', 'dismiss_required_action'],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: {
                    id: jQuery(this).attr('id'),
                    option: jQuery(this).attr('data-option')
                }
            }, Ajax, replace, replaceText;
            if (section.ajax) {
                return;
            }
            section.ajax = true;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                section.ajax = false;
                if (Ajax.result && 'ok' === Ajax.result.message) {
                    /**
                     * Fade the current element and show the next one.
                     * We don't need to remove it at this time. Leave it to for
                     * server side
                     */
                    container.fadeOut('200', function () {
                        if (next.is('p')) {
                            replace = title.find('.section-title');
                            replaceText = replace.attr('data-social');
                            replace.text(replaceText);
                        }
                        next.css({ opacity: 1, height: 'initial' }).fadeIn('200');
                    });
                }
            });
        });
    };
    /**
     * Dismiss Action
     * @private
     */
    EpsilonSectionRecommended.prototype._dismissAction = function () {
        var section = this;
        var trigger = this.context.find('.epsilon-dismiss-required-action');
        trigger.on('click', function (e) {
            var self = jQuery(this);
            /**
             * Get the container
             * @type {JQuery}
             */
            var container = self.parents('.epsilon-recommended-actions-container'), 
            /**
             * Get the title
             *
             * @type {JQuery}
             */
            title = container.parents('.control-section-epsilon-section-recommended-actions').find('h3'), 
            /**
             * Get the indew from the notice
             *
             * @type {JQuery}
             */
            notice = title.find('.epsilon-actions-count > .current-index'), 
            /**
             * Get the next element ( this will be shown next )
             */
            next = container.next(), 
            /**
             * Create the args object for the AJAX call
             *
             * action [ Class, Method Name ]
             * args [ parameters to be sent to method ]
             *
             * @type {{action: [*], args: {id: *, option: *}}}
             */
            args = {
                action: ['Epsilon_Notify_System', 'dismiss_required_action'],
                nonce: EpsilonWPUrls.ajax_nonce,
                args: {
                    id: jQuery(this).attr('id'),
                    option: jQuery(this).attr('data-option')
                }
            }, replace, plugins, replaceText, 
            /**
             * Get the total
             *
             * @type {Number}
             */
            total = notice.attr('data-total'), 
            /**
             * Get the current index
             *
             * @type {Number}
             */
            index = container.attr('data-index'), Ajax;
            if ('undefined' !== total) {
                total = parseInt(total);
            }
            if ('undefined' !== index) {
                index = parseInt(index);
            }
            if (section.ajax) {
                return;
            }
            section.ajax = true;
            Ajax = new epsilon_ajax_request_1.EpsilonAjaxRequest(args);
            Ajax.request();
            jQuery(Ajax).on('epsilon-received-success', function (e) {
                section.ajax = false;
                if (Ajax.result && 'ok' === Ajax.result.message) {
                    /**
                     * If it's the last element, show plugins
                     */
                    if (total <= index) {
                        replace = title.find('.section-title');
                        plugins = jQuery('.epsilon-recommended-plugins');
                        replaceText = replace.attr('data-social');
                        if (plugins.length) {
                            replaceText = replace.attr('data-plugin_text');
                        }
                        title.find('.epsilon-actions-count').remove();
                        replace.text(replaceText);
                    }
                    else {
                        notice.text(index + 1);
                    }
                    /**
                     * Fade the current element and show the next one.
                     * We don't need to remove it at this time. Leave it to for
                     * server side
                     */
                    container.fadeOut('200', function () {
                        next.css({ opacity: 1, height: 'initial' }).fadeIn('200');
                    });
                }
            });
        });
    };
    return EpsilonSectionRecommended;
}());
exports.EpsilonSectionRecommended = EpsilonSectionRecommended;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/sections/recommended-actions.ts
// module id = 43
// module chunks = 0